import React from 'react'
import { useTranslation } from 'react-i18next'
import ReactHtmlParser from 'react-html-parser'
import { Textarea } from '@navent-jobs/ui-kit/components/textarea'
import { Link } from '@navent-jobs/ui-kit/components/link'
import { Icon } from '@navent-jobs/ui-kit/components/icon'
import RadioButton from '@navent-jobs/ui-kit/components/RadioButton'
import Text from '@navent-jobs/ui-kit/components/text'
import { Input } from '@navent-jobs/ui-kit/components/input'
import { OptionTitle, Spacer } from './mixins'
import { portalsBySiteId } from '../../../../../../../../constants/portalesBySiteId'
import { SITE_ID } from '../../../../../../../../constants'
import motivosDenunciaData from '../../data.json'

const MOTIVO_ID_OTRO = 6

const Component = ({
  motivos,
  motivoSeleccionado,
  setSubOptionSelected,
  subOptionSelected,
  textareaValue,
  setTextareaValue,
}) => {
  const { t } = useTranslation()

  if (!motivoSeleccionado) {
    return null
  }

  const motivo = motivos.find(m => m.id === motivoSeleccionado)
  const motivoData = motivosDenunciaData.motivos.find(m => m.id === motivoSeleccionado)
  const options = motivo.subMotivos.map(sm => ({ id: sm.id, opcion: sm.descripcion }))

  if (!motivo || !motivoData) {
    return null
  }

  return (
    <>
      <OptionTitle>
        <Text size="lg">{ReactHtmlParser(t(`modalDenuncia.titles.${motivoSeleccionado}`))}</Text>
      </OptionTitle>
      {motivoData.description && <Text size="md">{motivoData.description}</Text>}
      {motivoData.pasteLink && (
        <Spacer>
          <Input
            id="inputAvisoDuplicado"
            name="inputAvisoDuplicado"
            type="text"
            value={textareaValue}
            placeholder={t('modalDenuncia.avisoDuplicado')}
            onChange={e => setTextareaValue(e.target.value)}
            fieldOptions={{
              label: 'Enlace al aviso original',
              variant: 'darken',
              maxLength: 200,
              before: <Icon name="icon-light-link-2" color="#0a26ee" size="24" />,
            }}
          />
        </Spacer>
      )}
      {options && options.length > 0 && (
        <RadioButton
          id="recommended"
          name="recommended"
          onChange={e => {
            setSubOptionSelected(+e.target.value)
          }}
          value={subOptionSelected}
          options={options}
          fieldOptions={{
            size: 'small',
            direction: 'column',
            ...{ style: { marginBottom: 0 } },
          }}
        />
      )}
      {motivoData.showTextArea && (
        <Spacer>
          <Textarea
            id="id-pregunta"
            placeholder={t('modalDenuncia.textArea')}
            name="name-pregunta"
            fieldOptions={{
              label: 'Danos detalles',
              variant: 'darken',
              allowOnlyText: true,
              ...{ style: { overflowY: 'scroll' } },
            }}
            rules={{
              required: true,
            }}
            maxLength={1000}
            value={textareaValue}
            onChange={e => setTextareaValue(e.target.value)}
            disabled={subOptionSelected === 0 && motivoSeleccionado !== MOTIVO_ID_OTRO}
          />
        </Spacer>
      )}

      <Text size="sm">
        Al hacer clic en denunciar, aceptas los{' '}
        <Link
          href="/terminos-y-condiciones"
          linkoptions={{ target: '_blank', ...{ style: { padding: 0, lineHeight: '20px' } } }}
        >
          Términos y Condiciones de Uso
        </Link>{' '}
        y las{' '}
        <Link
          href="/politica-de-privacidad"
          linkoptions={{ target: '_blank', ...{ style: { padding: 0, lineHeight: '20px' } } }}
        >
          Política de privacidad
        </Link>{' '}
        de {portalsBySiteId[SITE_ID || 'BMAR']} para crear una cuenta y denunciar los avisos.
      </Text>
    </>
  )
}

export default Component
